// extracted by mini-css-extract-plugin
export var dateLabel = "_4m-0";
export var dateLabelError = "_4m-1";
export var fullWidth = "_4m-2";
export var smaller = "_4m-3";